import ModalProvider from "@/common/contexts/Modal.context";
import TableFiltersContextProvider from "@/common/contexts/Table.context";
import { guardCheck } from "@/common/utils";
import { Loader } from "@/components";
import { lazy, Suspense } from "react";
import { redirect } from "react-router";

const Price = lazy(() => import("@/pages/AIRXPages/Price.page"));
const PriceMePage = lazy(() => import("@/pages/VendorsPages/PriceMe.page"));

const priceRoute = [
  {
    path: "price-list/me",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "priceList/vendor");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <TableFiltersContextProvider>
        <ModalProvider>
          <Suspense fallback={<Loader />}>
            <PriceMePage />
          </Suspense>
        </ModalProvider>
      </TableFiltersContextProvider>
    ),
  },
  {
    path: "price-list",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "priceList/airx");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <TableFiltersContextProvider>
        <ModalProvider>
          <Price />
        </ModalProvider>
      </TableFiltersContextProvider>
    ),
  },
];

export default priceRoute;
